module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    staticClass: "payment-method-select",
    model: {
      value: (_vm.inner_value),
      callback: function($$v) {
        _vm.inner_value = $$v
      },
      expression: "inner_value"
    }
  }, _vm._l((_vm.payment_methods), function(method, key) {
    return _c('el-option', {
      key: method.name,
      attrs: {
        "label": method.display,
        "value": method.name
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b80b6ea0","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/PaymentMethodSelect.vue
// module id = 314
// module chunks = 0